import { CircleLogo } from "@/react/components/OnboardingComponents/CircleLogo";

const HEADER_MAX_WIDTH = {
  mobile: "max-w-[450px]",
  tablet: "md:max-w-2xl",
  desktop: "lg:max-w-2xl",
  xl: "xl:max-w-lg",
};

const HEADER_MARGIN_TOP = {
  mobile: "mt-2",
  tablet: "md:mt-12",
  desktop: "lg:mt-12",
  xl: "xl:mt-16",
};

export const Header = () => (
  <div
    className={[
      "mx-auto w-full",
      ...Object.values(HEADER_MAX_WIDTH),
      ...Object.values(HEADER_MARGIN_TOP),
    ].join(" ")}
  >
    <div className="mb-8 flex items-center justify-between">
      <CircleLogo className="text-primary-900 h-8" />
    </div>
  </div>
);
